import { FaArrowAltCircleLeft } from "react-icons/fa";
import { TableCardTop, BackButtons, ButtonText } from "./BackButton.styles";

/**
 * Back button. Prefer an explicit `to` (the logical parent page, e.g. users ->
 * departments) so "Back" follows the data hierarchy rather than raw browser
 * history. Falls back to history back when no destination is given.
 */
const BackButton = (props: any) => {
    const { navigate, to } = props;
    return (
        <TableCardTop>
            <BackButtons
                backgroundColorHex="#135185"
                onClick={() => (to ? navigate(to) : navigate(-1))}
            >
                <FaArrowAltCircleLeft />
                <ButtonText>Back</ButtonText>
            </BackButtons>
        </TableCardTop>
    );
};

export default BackButton;
